import { useSearchParams } from "react-router-dom";
import { useAttributeReviewFieldMappingsQuery } from "@/graphql/generated";
import {
  fieldMappingsVariables,
  isFinishedEditUrl,
} from "@/lib/attributeReview/fieldMappingsVariables";

export function useKindOptions(sessionId: string) {
  const [searchParams] = useSearchParams();
  const { data = [] } = useAttributeReviewFieldMappingsQuery(
    fieldMappingsVariables(sessionId, isFinishedEditUrl(searchParams)),
    {
      select: (payload) =>
        payload.attributeReviewFieldMappings?.kindOptions ?? [],
      staleTime: Infinity,
      enabled: Boolean(sessionId),
    },
  );
  return data;
}
